import React, { Component } from 'react';
import { Grid, Typography, FormControlLabel, FormControl, Input, InputLabel, Switch, TextField, Modal, Button, Paper, MenuItem } from '@material-ui/core';

import SectorFamilyService from '../../../tools/SectorFamilyService';
import TreatmentsService from '../../../tools/TreatmentsService';

//msgs
import { msgAction, msgSimple } from '../../../actions/snackbarActions';
import { connect } from 'react-redux';

class ModalUsers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: '',
            user: {
                id: 'new',
                first_name: '',
                active: true,
                email: '',
                profile: '',
                war_name: '',
                last_name: '',
                phone1: '',
                phone2: '',
                treatment_id: '',
                sector_id: '',
                Treatment: {
                    name: '',
                    id: ''

                },
                Sector: {
                    name: '',
                    id: ''

                }

            },
            profiles: [
                'Administração',
                'Coordenação',
                'Manutenção',
                'Operações',
                'Solicitante',

            ],
            sectors: [
            ],
            treatments: [
            ]
        }
    }

    onRender = () => {
        SectorFamilyService.get(null,null,true,null,true).then(result => {
            this.setState({ loading: false })
            if (result.ok) {
                this.setState({ sectors: result.response })
            }
        })

        TreatmentsService.get(null,null,true,null,true).then(result => {
            this.setState({ loading: false })
            if (result.ok) {
                this.setState({ treatments: result.response })
            }
        })

        if (this.props.modal.id !== 'new') {
            this.setState({ user: this.props.modal })
        }
        else {
            this.setState({
                user: {
                    id: 'new',
                    first_name: '',
                    active: true,
                    email: '',
                    profile: '',
                    war_name: '',
                    last_name: '',
                    phone1: '',
                    phone2: '',
                    treatment_id: '',
                    sector_id: '',
                    Sector: {
                        name: '',
                    },
                    Treatment: {
                        name: '',
                    }
                }
            })
        }
    }

    render() {
        return (
            <Modal
                style={{ overflowX: 'hidden' }}
                open={this.props.openModal}
                onRendered={this.onRender}
            >
                <Grid style={{ height: '100%', overflowX: 'hidden' }} justify="center" alignItems="center" container xs={12} sm={12} md={12} lg={12} xl={12}  >
                    <Grid item container xs={12} sm={8} md={8} lg={8} xl={4} >
                        <Paper style={{ height: '100%', width: '100%', padding: 25 }}>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography variant="title" id="modal-title">
                                    {this.props.modal.id === 'new' ? "Novo Usuário" : "Editar Usuário"}
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Typography style={{ marginTop: 14, marginRight: 10 }} variant="subheading" id="modal-title">
                                    Ativo:
                                 </Typography>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id='active'
                                            checked={this.state.user.active}
                                            onChange={event => {
                                                let { user } = this.state;
                                                this.setState({ user: { ...user, active: event.target.checked } })
                                            }}
                                            color="primary"
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container spacing={8} >
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                                    <TextField
                                        id="first_name"
                                        label="Nome (Como no passaporte)*"
                                        style={{ width: '100%' }}
                                        value={this.state.user.first_name}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, first_name: event.target.value } })
                                        }}
                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TextField
                                        id="last_name"
                                        label="Sobrenome (Como no passaporte)"
                                        style={{ width: '100%' }}
                                        value={this.state.user.last_name}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, last_name: event.target.value } })
                                        }}
                                        margin="normal"
                                    />
                                </Grid>
                            </Grid>
                            
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container spacing={8}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} >
                                    <TextField
                                        id="sector_family"
                                        select
                                        label="Função/Familia*"
                                        style={{ width: '100%' }}
                                        value={this.state.user.sector_id}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, sector_id: event.target.value } })
                                        }}
                                        margin="normal"
                                    >
                                        <MenuItem disabled>
                                            Selecione o Função/Família
                                        </MenuItem>
                                        {this.state.sectors && this.state.sectors.map(sector_family => (
                                            <MenuItem key={sector_family.id} value={sector_family.id}>
                                                {sector_family.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TextField
                                        id="profile"
                                        select
                                        label="Perfil/Setor*"
                                        style={{ width: '100%' }}
                                        value={this.state.user.profile}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, profile: event.target.value } })
                                        }}
                                        margin="normal"
                                    >
                                        <MenuItem disabled>
                                            Selecione o Perfil
                                    </MenuItem>
                                        {this.state.profiles && this.state.profiles.map(profile => (
                                            <MenuItem key={profile} value={profile}>
                                                {profile}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container spacing={8} >
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}  >
                                    <TextField
                                        id="email"
                                        label="E-mail 1* (Login)"
                                        style={{ width: '100%' }}
                                        value={this.state.user.email}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, email: event.target.value } })
                                        }}

                                        margin="normal"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                    <TextField
                                        id="phone1"
                                        label="Celular"
                                        style={{ width: '100%' }}
                                        value={this.state.user.phone1}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, phone1: event.target.value } })
                                        }}

                                        margin="normal"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} container spacing={8} >
                                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} >
                                    <TextField
                                        id="phone2"
                                        label="Outro Telefone"
                                        style={{ width: '100%' }}
                                        value={this.state.user.phone2}
                                        onChange={event => {
                                            let { user } = this.state;
                                            this.setState({ user: { ...user, phone2: event.target.value } })
                                        }}

                                        margin="normal"
                                    />
                                </Grid>

                                {this.state.user.id === 'new' &&
                                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <FormControl margin="normal" required fullWidth>
                                            <InputLabel htmlFor="password">Senha</InputLabel>
                                            <Input
                                                name="password"
                                                type="password"
                                                id="password"
                                                // autoComplete="current-password"
                                                style={{ width: '100%' }}
                                                onChange={event => {
                                                    let { user } = this.state;
                                                    this.setState({ user: { ...user, password: event.target.value } })
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                            </Grid>
                            <Grid style={{ marginTop: 40 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Button
                                    style={{ float: 'right' }}
                                    color="secondary"
                                    onClick={() => this.props.func()}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    style={{ float: 'right' }}
                                    color="primary"
                                    onClick={() => {
                                        if (this.state.user.war_name !== '' && this.state.user.first_name !== '' && this.state.user.treatment_id !== '' && this.state.user.sector_id !== '' && this.state.user.profile !== '' && this.state.user.password !== '')
                                            this.props.handleSave(this.state.user)
                                        else
                                            this.props.msgSimple('Preencha os campos obrigatórios.')
                                    }}
                                >
                                    Salvar
                                </Button>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </Modal>
        );
    }
}


const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {
    msgSimple
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalUsers)




// WEBPACK FOOTER //
// ./src/routes/settings/users/Modal.js